






















import Vue from "vue";
export default Vue.extend({
    name: 'FeaturesOfSpectra',
    props: ['features', 'phis'],
    data() {
        return {
            columns: [{
                name: 'name',
                label: 'Name',
                sortable: true,
                field: 'name'
            }, {
                name: 'intensity',
                field: 'intensity',
                sortable: true,
                label: 'Intensity'
            }, {
                name: 'motifs',
                field: 'motifs',
                label: 'Mass2Motif (prob)'
            }],
            pagination: {
                sortBy: 'name',
                rowsPerPage: 25
            }
        }
    },
    computed: {
        data() {
            return Object.entries(this.features).map(([name, intensity]) => {
                const motifs = Object.entries(this.phis[name]).map(
                    ([motif, prob]) => {return {id: motif, prob}}
                );
                return {
                    name, intensity, motifs
                };
            })
        }
    },
});
